import { GuestInboxStayDetail, GuestInboxTimelineEvent } from '../../StayTimeline.types'
import * as S from './HandledStrip.styles'
import { getHandledStrip } from './HandledStrip.utils'

interface HandledStripProps {
  detail: GuestInboxStayDetail
  conversation: GuestInboxTimelineEvent[]
}

export const HandledStrip = ({ detail, conversation }: HandledStripProps) => {
  const strip = getHandledStrip(detail, conversation)
  if (!strip) return null

  const trail = [strip.work, strip.solved, strip.ack].filter(Boolean).join(' · ')

  return (
    <S.Root $isWarning={strip.isWarning}>
      <S.Label $isWarning={strip.isWarning}>How this was handled</S.Label>
      <S.Lead>{strip.head}</S.Lead>
      {strip.said ? <S.Said>“{strip.said}”</S.Said> : null}
      <S.Trail>{trail}</S.Trail>
    </S.Root>
  )
}
